// extracted by mini-css-extract-plugin
module.exports = {"header":"Header-module__header___3DCdM","profileContainer":"Header-module__profileContainer___1nZHJ","icon":"Header-module__icon___3N3zs"};